// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.audit_operation */
var AuditOperation;
(function (AuditOperation) {
    AuditOperation["INSERT"] = "INSERT";
    AuditOperation["UPDATE"] = "UPDATE";
    AuditOperation["DELETE"] = "DELETE";
})(AuditOperation || (AuditOperation = {}));
;
export default AuditOperation;
/** Zod schema for audit_operation */
export const auditOperation = z.nativeEnum(AuditOperation);
//# sourceMappingURL=AuditOperation.js.map